import { useEffect, useState } from "react";

/**
 * Current time, re-rendered every `intervalMs` while `active`. Browsers throttle or freeze timers
 * in background tabs, so the clock also re-reads `Date.now()` the moment the tab is visible again;
 * every countdown derived from it is therefore correct after sleep/wake.
 */
export function useNow(intervalMs = 1000, active = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const tick = () => setNow(Date.now());
    tick();
    const handle = window.setInterval(tick, intervalMs);
    const onVisible = () => {
      if (document.visibilityState === "visible") tick();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", tick);
    return () => {
      window.clearInterval(handle);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", tick);
    };
  }, [intervalMs, active]);
  return now;
}
